module.exports = __webpack_public_path__ + "static/media/btn_flasche.ae447dd3.png";